"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const hooks_1 = require("../hooks");
const change_case_1 = require("change-case");
const Inner_1 = require("./Inner");
exports.BlockCanvasToolbar = () => {
    const { block: { type, fieldType }, meta: { displayName, hasVisibleChildBlocks, isChildBlock, hasSocialChildren, }, } = hooks_1.useEmailCanvasBlockDetailContext();
    const displayType = react_1.useMemo(() => {
        const f = type === 'field' ? fieldType : type;
        return `${f === 'url' || f === 'html'
            ? f.toUpperCase()
            : change_case_1.sentenceCase(type === 'field' ? fieldType : type)} block`;
    }, [type, fieldType]);
    return (react_1.default.createElement(Inner_1.BlockCanvasToolbarInner, { hasVisibleChildBlocks: hasVisibleChildBlocks, displayType: displayType, displayName: displayName, fieldType: fieldType, isChildBlock: isChildBlock, type: type, hasSocialChildren: hasSocialChildren }));
};
//# sourceMappingURL=index.js.map